const VFIAT_PER_EUR = 100_000;

export function vfiatToEur(vfiat: number): number {
  return vfiat / VFIAT_PER_EUR;
}

/** A balance in whole cents, rounded down so the credit shown is never more than the account holds. */
export function formatCredit(vfiat: number, lang: string): string {
  return formatEur(Math.floor(vfiat / (VFIAT_PER_EUR / 100)) / 100, lang, 2, 2);
}

/** The number locale for a UI language: British English for "en", Latin digits for Arabic like the rest of the UI. */
export function numberLocale(lang: string): string {
  const base = (lang || 'en').split('-')[0];
  if (base === 'en') return 'en-GB';
  if (base === 'ar') return 'ar-u-nu-latn';
  return base;
}

/** A count in the active language: "62,500" in English, "62.500" in German. */
export function formatNumber(n: number, lang: string): string {
  return new Intl.NumberFormat(numberLocale(lang)).format(n);
}

/** A percentage given in percent, not as a fraction: 10 is "10%" in English, "10 %" in German. */
export function formatPercent(n: number, lang: string, maxDigits = 0): string {
  return new Intl.NumberFormat(numberLocale(lang), {
    style: 'percent',
    maximumFractionDigits: maxDigits,
  }).format(n / 100);
}

/**
 * Euros in the active language ("€0.23", "0,23 €"), with as many decimals as
 * sub-cent prices need: 0.005, 0.0005, 8.60.
 */
export function formatEur(amount: number, lang: string, minDigits = 2, maxDigits = 4): string {
  return new Intl.NumberFormat(numberLocale(lang), {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: minDigits,
    maximumFractionDigits: Math.max(minDigits, maxDigits),
  }).format(amount);
}
